import { createStore } from "vuex";

export default createStore({
	state: {
		session: {},
	},
	getters: {},
	mutations: {
		setSession(state, payload) {
			state.session = payload
		},	},
	actions: {},
	modules: {},
});
